import { defineStore } from 'pinia'

export const useOpenBanking = defineStore('openBanking', {
  state: () => ({
    byOperationId: {},
  }),

  getters: {
    getByOperationId: (state) => (operationId) =>
      state.byOperationId[operationId] ?? null,
  },

  actions: {
    /**
     * Called from the amount form before POST create.
     *
     * @param {{ operationId: string, walletId: string, amount: string|number, currencyId: string }} intent
     */
    registerIntent({ operationId, walletId, amount, currencyId }) {
      this.byOperationId[operationId] = {
        operationId,
        walletId,
        amount,
        currencyId,
        status: null,
        redirectUrl: null,
      }
    },

    /**
     * Updates operation state from WebSocket payload (App.vue).
     *
     * @param {object} payload
     * @param {string} payload.id - operation UUID
     * @param {string} payload.walletId
     * @param {string} [payload.status]
     * @param {string|number} [payload.amount]
     * @param {string} [payload.currencyId]
     * @param {string} [payload.redirectUrl]
     */
    applyWsPayload(payload) {
      const operationId = payload.id
      const { walletId, status, amount, currencyId, redirectUrl } = payload
      const existing = this.byOperationId[operationId]

      if (existing && existing.walletId !== walletId) {
        return
      }

      // Do not downgrade from SETTLED to an earlier status (e.g. late PendingCredit)
      const nextStatus =
        existing?.status === 'SETTLED'
          ? 'SETTLED'
          : status ?? existing?.status ?? null

      this.byOperationId[operationId] = {
        operationId,
        walletId,
        amount: amount ?? existing?.amount,
        currencyId: currencyId ?? existing?.currencyId,
        status: nextStatus,
        redirectUrl: redirectUrl ?? existing?.redirectUrl ?? null,
      }
    },
  },
})
